import { useEffect } from "react"
import { IBackgroundProps } from "../Background";

/* Protopia Ecosystem component */
export interface IBackgroundBokehProps { 
   
}
const BackgroundBokeh = ({section, ...props}: IBackgroundProps): JSX.Element => {
    const bg = section.background
    const color = bg.color
    useEffect(() => {
        /*
        * File Name / glitteringSea.js
        * Created Date / Aug 14, 2020
        * Aurhor / Toshiya Marukubo
        * Twitter / https://twitter.com/toshiyamarukubo
        * https://codepen.io/rjnjbnwz-the-solid/pen/JoXrrLJ
        */
        const doBoke = () => {
            const canvas: HTMLCanvasElement = document.getElementById('canvas')! as HTMLCanvasElement;

            if (!canvas || !canvas.getContext) { 
                return false;
            } 

            /********************
             Random Number
            ********************/

            function rand(min: number, max: number) {
                return Math.floor(Math.random() * (max - min + 1) + min);
            }
            
            /********************
             Var
            ********************/

            var ctx: CanvasRenderingContext2D = canvas.getContext('2d')!;
            canvas.width = window.innerWidth + 100;
            var X = canvas.width - 100
            var Y = canvas.height = window.innerHeight; 
            var shapeNum = 300;
            var shapes : any[] = [];

            /********************
             Animation
            ********************/

            window.requestAnimationFrame =
                window.requestAnimationFrame ||
                function(cb) {
                    setTimeout(cb, 17);
                };

            /********************
             Shape
            ********************/
            
            function Shape(ctx: HTMLCanvasElement, x: number, y: number) {
                this.ctx = ctx;
                this.init(x, y);
            }
            
            Shape.prototype.init = function(x: number, y : number) {
                this.x = x;
                this.y = y;
                this.r = rand(10, bg.color_size);
                this.ga = Math.random() * Math.random() * Math.random() * Math.random();
                this.v = {
                    x: Math.random(),
                    y: -1
                };
                this.l = rand(0, 2000);
                this.sl = this.l;
            };

            Shape.prototype.updateParams = function() {
                var ratio = this.l / this.sl;
                //this.r *= ratio;
                this.l -= 1;
                if (this.l < 0) {
                    this.init(X * (Math.random() + Math.random()) / 2, rand(0, Y));
                }
            };

            Shape.prototype.updatePosition = function() {
                this.x += Math.random();
                this.y += -Math.random();
            };
            
            Shape.prototype.draw = function() {
                var ctx  = this.ctx;
                ctx.save();
                ctx.globalCompositeOperation = 'lighter';
                ctx.globalAlpha = this.ga;
                //ctx.fillStyle = 'rgb(123, 252, 100)';
                ctx.fillStyle = 'white';
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2, false);
                ctx.fill();
                ctx.restore();
            };

            Shape.prototype.render = function(i) {
                this.updatePosition();
                this.updateParams();
                this.draw();
            };

            for (var i = 0; i < shapeNum; i++) {
                var s = new Shape( 
                    ctx, 
                    X * (Math.random() + Math.random()) / 2, 
                    rand(0, Y) 
                );
                shapes.push(s);
            }

            /********************
             Render
            ********************/
            
            function render() {
                ctx?.clearRect(0, 0, X, Y);
                for (var i = 0; i < shapes.length; i++) {
                    shapes[i].render(i);
                }
                requestAnimationFrame(render);
            }

            render();

            /********************
             Event
            *******************
            
            function onResize() {
                X = canvas.width = window.innerWidth;
                Y = canvas.height = window.innerHeight;
            }

            window.addEventListener('resize', function() {
                onResize();
            });

            window.addEventListener('mousemove', function(e) {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }, false); 
            */
        }
        doBoke()
    }, [])
    return <div className='pe-background-boke' style={{
        background: color || "#00222B",
        filter: "blur(4px)",
        width: "100%",
        height: "100%",
        position: "absolute",
        top:0,
        left:0,

    }}>
       <canvas id="canvas"></canvas>
    </div>
}
export default BackgroundBokeh